import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import DemandTypeModel         from 'models/DemandTypeModel';

export const EXEMPTION_DELIVERY = 'exemption_delivery';
export const EXEMPTION_MOUNTING = 'exemption_mounting';
export const EXEMPTION_DISMANTLING = 'exemption_dismantling';
export const LOGISTIC_VEHICLE = 'logistic_vehicle';
export const LOGISTIC_MATERIAL = 'logistic_material';

export const EXEMPTIONS = [EXEMPTION_DELIVERY, EXEMPTION_DISMANTLING, EXEMPTION_MOUNTING];

export const LOGISTICS = [LOGISTIC_MATERIAL, LOGISTIC_VEHICLE];

export const getDemandTypeIntlLabel = (demandType: DemandTypeModel) => {
  switch (demandType.reference) {
    case LOGISTIC_VEHICLE:
      return <FormattedMessageWrapper id="Véhicule" />;
    case LOGISTIC_MATERIAL:
      return <FormattedMessageWrapper id="Matériel" />;
    case EXEMPTION_DELIVERY:
    case EXEMPTION_MOUNTING:
    case EXEMPTION_DISMANTLING:
    default:
      return <FormattedMessageWrapper id={demandType.label} />;
  }
};

export const getDemandTypeIntlLongLabel = (demandType: DemandTypeModel) => {
  switch (demandType.reference) {
    case LOGISTIC_VEHICLE:
      return <FormattedMessageWrapper id="Logistique - Véhicule" />;
    case LOGISTIC_MATERIAL:
      return <FormattedMessageWrapper id="Logistique - Matériel" />;
    case EXEMPTION_DELIVERY:
      return <FormattedMessageWrapper id="Dérogation - Livraison" />;
    case EXEMPTION_MOUNTING:
      return <FormattedMessageWrapper id="Dérogation - Montage" />;
    case EXEMPTION_DISMANTLING:
      return <FormattedMessageWrapper id="Dérogation - Démontage" />;
    default:
      return null;
  }
};
